import './Filters.scss'
import { Filter } from './components/Filter/Filter'
import { useContext, useMemo } from 'react'
import FiltersContext from '../../../Context/FiltersContext'
import { IProyectos } from '../../data/data.model'

import { useTranslation } from 'react-i18next'

interface FiltersProps {
  data: IProyectos[]
  // lang: string
}

export const Filters = ({ data }: FiltersProps) => {
  const { t }: any = useTranslation()
  const { filterCategories, filtersSelected } = useContext(FiltersContext)

  // Get options
  const extractFilterOptions = (keyToFind: string): string[] => {
    const dataSet = new Set<string>()
    data.forEach((project: any) => {
      if (project[keyToFind]) {
        if (Array.isArray(project[keyToFind])) {
          project[keyToFind].forEach((keyEle: string) => {
            if (
              !!keyEle &&
              keyEle !== 'No disponible' &&
              keyEle !== 'Not available' &&
              keyEle !== 'Não disponível'
            )
              dataSet.add(keyEle.trim())
          })
        } else {
          if (
            project[keyToFind] !== 'No disponible' &&
            project[keyToFind] !== 'Not available' &&
            project[keyToFind] !== 'Não disponível'
          ) {
            dataSet.add(project[keyToFind])
          }
        }
      }
    })
    return Array.from(dataSet)
  }

  // Get Filters -> modificar para usar la data quemada con ids (falta la data actualizada)
  const filters = useMemo(() => {
    return filterCategories.map(
      (category: { name: string; filterKey: string }) => {
        let options: { label: string; value: any }[] = []

        switch (category.filterKey) {
          case 'country':
            options.push(
              ...[
                { label: t('countries.brazil'), value: 'brazil' },
                { label: t('countries.peru'), value: 'peru' },
                { label: t('countries.mexico'), value: 'mexico' },
                { label: t('countries.guyana'), value: 'guyana' },
                { label: t('countries.bolivia'), value: 'bolivia' },
                { label: t('countries.paraguay'), value: 'paraguay' },
                { label: t('countries.argentina'), value: 'argentina' },
                { label: t('countries.chile'), value: 'chile' },
              ]
            )
            break
          case 'state_or_province_or_region_or_department':
            const countries = filtersSelected.country.map(
              (country: { label: string; value: string }) => country.value
            )
            // Si el país seleccionado es "Todos", incluir todos los departamentos
            const pDepartments = countries.includes(t('filters.all'))
              ? data
                  .map(
                    (project) =>
                      project.state_or_province_or_region_or_department
                  )
                  .filter(Boolean)
              : data
                  .filter((project) => countries.includes(project.country))
                  .map(
                    (project) =>
                      project.state_or_province_or_region_or_department
                  )
                  .filter(Boolean)

            const dataSet = new Set<string>()
            pDepartments.forEach((pDepartment: string[]) => {
              if (!!pDepartment && pDepartment.length)
                pDepartment.forEach((dept) => {
                  dataSet.add(dept.trim())
                })
            })

            options.push(
              // ...Array.from(new Set(...departments)).map((dept) => ({
              ...Array.from(dataSet).map((dept) => ({
                label: dept,
                value: dept,
              }))
            )
            break

          case 'bioma_or_region':
            options.push(
              ...extractFilterOptions('bioma_or_region').map((id_bioma) => ({
                label: t(`biomas.${id_bioma}`),
                value: id_bioma,
              }))
            )
            break

          case 'empresas': // Key para la desarrolladora
            options.push(
              ...extractFilterOptions('empresas').map((empresa) => ({
                label: empresa,
                value: empresa,
              }))
            )
            break

          case 'area_overlap': //key para el certificador
            options.push(
              // ...extractFilterOptions('area_overlap').map((area_overlap) => ({
              //   label: t(`project.overlap.${area_overlap}`),
              //   value: area_overlap,
              // }))
              ...[
                { label: t('project.overlap.yes'), value: 'yes' },
                { label: t('project.overlap.no'), value: 'no' },
                { label: t('project.overlap.maybe'), value: 'maybe' },
                { label: t('project.overlap.near'), value: 'near' },
              ]
            )
            break

          case 'community_overlap': // Key para el auditor
            options.push(
              // ...extractFilterOptions('community_overlap').map(
              //   (community_overlap) => ({
              //     label: t(`project.overlap.${community_overlap}`),
              //     value: community_overlap,
              //   })
              // )
              ...[
                { label: t('project.overlap.yes'), value: 'yes' },
                { label: t('project.overlap.no'), value: 'no' },
                { label: t('project.overlap.maybe'), value: 'maybe' },
                { label: t('project.overlap.near'), value: 'near' },
              ]
            )
            break

          default:
            break
        }

        options = [
          { label: t('filters.all'), value: t('filters.all') },
          ...options.sort((a: any, b: any) => a.label.localeCompare(b.label)),
        ]

        return (
          <Filter
            key={category.name}
            filterKey={category.filterKey}
            category={category.name}
            options={options}
          />
        )
      }
    )
  }, [data, filterCategories, filtersSelected])

  return (
    <>
      {/* <div className="country-filters_container">
        <CountryFilters />
      </div> */}
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
        }}
      >
        {filters}
      </div>
    </>
  )
}
